import React from 'react';
import * as types from '../../types';
import { useLocale } from '../../contexts/LocaleContext';
import { useTranslation } from 'react-i18next';
import { Text } from '@mantine/core';

export default function PricesInCurrencyMessage() {
  const { currency } = useLocale();
  const { t } = useTranslation();

  if (!currency || currency === types.FiCurrency.USD) {
    return <></>;
  }

  // TODO: styling: https://app.asana.com/1/553833434016848/project/1207101507783044/task/1212007940669241?focus=true
  return (
    <Text fz={14} fw={600} my={16}>
      {t('all_prices_are_in_currency', { currency: currency })}
    </Text>
  );
}
